import { Formik } from 'formik'
import { Form as BaseForm } from 'components/Wizards/Form/Form'
import { FormProps } from './Types'
import { PropsWithChildren } from 'react'
import { Sections } from './Sections'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { ConditionalLanguageInputField as LanguageInputField } from './LanguageInputField/ConditionalLanguageInputField'

const Form = ({ schema, initialValues, onSubmit, children, initialFormStatus }: PropsWithChildren<FormProps>) => {
  const {
    meta: { submitLabel = 'Generate' },
  } = schema.describe()

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={initialValues}
      initialStatus={initialFormStatus}
    >
      <BaseForm.Root>
        <Sections.Root schema={schema}>
          <Sections.ManualFieldsSection />
          <Sections.AutoFillFieldsSection>
            <ResponsiveDesign.Mobile>
              <LanguageInputField />
            </ResponsiveDesign.Mobile>
          </Sections.AutoFillFieldsSection>
          <BaseForm.Actions isSticky>
            <BaseForm.PrimaryActions>
              {children || <BaseForm.SubmitButton>{submitLabel}</BaseForm.SubmitButton>}
            </BaseForm.PrimaryActions>
          </BaseForm.Actions>
        </Sections.Root>
      </BaseForm.Root>
    </Formik>
  )
}

export { Form }
